import {
  getCutHeight,
  getPatternLetter,
  getPlayersList,
  getCategoryName,
  getVisibleAttributes,
  parseColorValue,
  getImageAttributes, parseFontName, parseStrokeWidth
} from "../../utils/order/customAttributes";
import { Item } from '../../models/item';
import React from "react";
import { VisibleAttributes } from "./sections";

export type ManufacturerEmailProps = {
  orderId: string;
  items: Item[];
  notes: { [key: string]: string };
};

const ManufacturerEmail = ({ orderId, items, notes }: ManufacturerEmailProps) => {
  return (
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Order {orderId}</title>
      </head>
      <body
        style={{
          width: '100%',
          margin: 0,
          padding: 0,
          fontFamily: '"Arial", serif',
          WebkitTextSizeAdjust: '100%',
          MsTextSizeAdjust: '100%',
        }}
      >
        <h2>PO {orderId}</h2>
        <div>List of items in order:</div>

        {items.map((item, i) => {
          const productName = getCategoryName(item.customAttributes);
          const patternLetter = getPatternLetter(
            item.customAttributes,
            item.title,
          );
          const cutHeight = getCutHeight(item.title);
          const visibleAttrs = getVisibleAttributes(item.customAttributes);
          const imageAttrs = getImageAttributes(item.customAttributes);
          const playersList = getPlayersList(item.customAttributes);
          const note = notes[item.id];

          return (
            <div
              key={i}
              style={{
                paddingLeft: 24,
                paddingTop: 24,
                paddingRight: 24,
                paddingBottom: 24,
              }}
            >
              <h3>
                {i + 1}. {item.title}
              </h3>

              <table style={{ width: '100%' }} border={0}>
                <tr>
                  <td>
                    <table
                      style={{ width: '30%', marginBottom: 20 }}
                      align="left"
                      border={0}
                    >
                      <tr>
                        <td>
                          <img
                            src={item.image.url}
                            alt={item.title}
                            width={250}
                            height={250}
                            style={{ objectFit: "contain", maxWidth: "100%" }}
                          />
                        </td>
                      </tr>
                    </table>

                    <table
                      style={{ width: '35%', marginBottom: 20 }}
                      align="left"
                      border={0}
                    >
                      <tr>
                        <td>
                          <div style={{ marginBottom: 10 }}>
                            <b>PO number: {orderId}</b>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div style={{ marginBottom: 10 }}>
                            {item.sku ? (
                              <div>
                                <b>SKU: {item.sku}</b>
                              </div>
                            ) : null}
                            <div>
                              <b>{item.variantTitle}</b>
                            </div>
                            <div style={{ marginBottom: 10 }}>
                              <b>Quantity: {item.quantity}</b>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div style={{ marginBottom: 10 }}>
                            {productName ? (
                              <div>Product name: {productName}</div>
                            ) : null}
                            {patternLetter ? (
                              <div>Pattern letter: {patternLetter}</div>
                            ) : null}
                            {cutHeight ? (
                              <div>Cut height: {cutHeight}</div>
                            ) : null}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div style={{ marginBottom: 10 }}>
                            {imageAttrs.map(attr => {
                              return <div key={attr.key}>
                                {attr.key.substring(1)} image: <a href={attr.value}>Link</a>
                              </div>
                            })}
                            {playersList && <div>Players List: <a href={playersList.value}>Download Roster</a></div>}
                          </div>
                        </td>
                      </tr>
                    </table>

                    <table
                      style={{ width: '35%', marginBottom: 20 }}
                      align="left"
                      border={0}
                    >
                      <tr>
                        <td>
                          <h4 style={{ marginTop: 0, paddingLeft: 20 }}>
                            Details
                          </h4>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <VisibleAttributes visibleAttrs={visibleAttrs} />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          {note && note.length > 0 ? (
                            <div
                              style={{
                                border: '1px solid #ccc',
                                backgroundColor: '#eee',
                                padding: 20,
                              }}
                            >
                              <h4 style={{ marginTop: 0 }}>Note</h4>
                              <div>{note}</div>
                            </div>
                          ) : null}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          );
        })}
      </body>
    </html>
  );
};

export default ManufacturerEmail;
